module.exports = __webpack_public_path__ + "img/pic_an_xzh@2x(3).d196ea17.png";